module.exports = __webpack_public_path__ + "static/media/totoro-back.21d98f67.jpg";